import { OrderByProvidersProviderCardContentProps } from './props';
import { useMemo } from 'react';
import Provider from './Provider';
import { ErrorCard } from '@starsoft/common/components';

export default function OrderByProvidersProviderCardContent({
  gameProviders,
  isFetchingNextPage,
  isLoading,
  refetch,
  error,
}: OrderByProvidersProviderCardContentProps) {
  const Providers = useMemo(
    () =>
      gameProviders?.map(provider => (
        <Provider key={`game-provider-${provider?.id}`} data={provider} />
      )),
    [gameProviders],
  );
  const Skeletons = useMemo(
    () =>
      Array.from({ length: 20 })?.map((_, i) => (
        <Provider key={`game-provider-skeleton-${i}`} isLoading />
      )),
    [],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  if (isLoading) {
    return Skeletons;
  }

  return (
    <>
      {Providers}

      {isFetchingNextPage && Skeletons}
    </>
  );
}
